<app-page-modifications>
  <app-header class="full-width"></app-header>
  <main id="content" class="js-content" role="main">
      <div class="grid-row">
          <div class="column-two-thirds">
            <p class="aa-title-size" tabindex="0">
              <strong>Not able to upload</strong>
            </p>
            <div class="notice">
              <strong class="visually-hidden">Warning</strong>
              <app-svg-warning></app-svg-warning>
              <strong class="aa-copy-size">
                Please tell your teacher
              </strong>
            </div>
            <br />
            <details>
              <summary><span class="summary aa-copy-size">Instructions for teachers</span></summary>
              <div class="panel no-border">
                <ol class="list list-number aa-copy-size">
                  <li>Press the ‘Try upload again’ button.</li>
                  <li>If that still does not work, please contact the helpline for advice on how to upload the check.</li>
                </ol>
                <div class="panel panel-border-wide aa-copy-size aa-contrast-border">
                  <div class="bold-small aa-copy-size">National curriculum assessments helpline</div>
                  <div>Telephone: 0300 303 3013</div>
                  <div>Monday to Friday, 9am to 5pm</div>
                </div>
              </div>
            </details>
            <br />
            <a routerLink="/check" [queryParams]="{unfinishedCheck: true}" class="button aa-button-size aa-contrast-button ultrawider" id="retry-button">
              Try upload again
            </a>
          </div>
      </div>
  </main>
</app-page-modifications>
